import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { Alert, Text } from '@reveni-io/reveni-ui'

import { getLanguageLabels } from '@/configuration/helpers/helpers'
import Preview from '@/configuration/pages/ConfigurationPage/CommunicationsConfiguration/components/Preview/Preview'
import PreviewSkeleton from '@/configuration/pages/ConfigurationPage/CommunicationsConfiguration/components/Preview/PreviewSkeleton/PreviewSkeleton'

import { liquidEditorHeight } from '../LiquidEditor/constants'
import * as Styles from './styles'

const LiquidPreview = ({ preview, fetchingPreview, liquidError, isLiquidContentEmpty, languageSelected }) => {
  const { t } = useTranslation()
  const theme = useTheme()

  if (fetchingPreview) {
    return <PreviewSkeleton iframeHeight={liquidEditorHeight} showAlert={false} />
  }

  if (isLiquidContentEmpty) {
    return (
      <Styles.MessageContainer>
        <Alert type="warning">
          {t('Todavía no hay HTML para {{language}}. Añádelo en la pestaña Código para ver la vista previa.', {
            language: getLanguageLabels(t)[languageSelected],
          })}
        </Alert>
      </Styles.MessageContainer>
    )
  }

  if (liquidError) {
    const errorDetail = liquidError.line
      ? t('Error: línea {{line}}, {{message}}', { line: liquidError.line, message: liquidError.message })
      : t('Error: {{message}}', { message: liquidError.message })

    return (
      <Styles.MessageContainer>
        <Alert type="error">
          <Text tag="span" type="bodyMBold">
            {t('No se puede mostrar la vista previa.')}
          </Text>{' '}
          {errorDetail}
        </Alert>
      </Styles.MessageContainer>
    )
  }

  if (!preview) return null

  return (
    <Styles.Container>
      <Styles.SubjectHeader>
        <Text type="bodySMedium" color={theme.colors.text.muted}>
          {t('Asunto')}:
        </Text>
        <Text type="bodySRegular">{preview.subject}</Text>
      </Styles.SubjectHeader>
      <Styles.EmailFrame>
        <Preview preview={preview.content} showAlert={false} iframeHeight={liquidEditorHeight} />
      </Styles.EmailFrame>
    </Styles.Container>
  )
}

export default LiquidPreview
